import { useMemo, useState } from "react";
import { Card, Input, Alert, Tag } from "antd";
import { useSelector } from "react-redux";
import MondayButton from "../../commonComponents/MondayButton/MondayButton";

// Paste past duty weeks (one per line: date, then the name) so fairness starts
// from what the office actually did instead of from zero. Import is matched on
// name; anything unmatched is reported rather than guessed.
const PLACEHOLDER = `09/03/2026, Jonian Abazi
16/03/2026, Olger Muçi`;

const parseLines = (raw) =>
  String(raw || "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const parts = line.split(/[,;\t]+/).map((p) => p.trim());
      if (parts.length < 2) return { raw: line, error: "format" };
      const [datePart, ...nameParts] = parts;
      const dmy = datePart.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/);
      const iso = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!dmy && !iso) return { raw: line, error: "date" };
      const weekStartDate = iso
        ? datePart
        : `${dmy[3]}-${dmy[2].padStart(2, "0")}-${dmy[1].padStart(2, "0")}`;
      return { weekStartDate, employeeName: nameParts.join(" ") };
    });

const HistoryImportPanel = ({ saving, onImportHistory }) => {
  const { isDarkMode } = useSelector((state) => state.usersList);
  const [raw, setRaw] = useState("");
  const [result, setResult] = useState(null);

  const parsed = useMemo(() => parseLines(raw), [raw]);
  const valid = parsed.filter((p) => !p.error);
  const invalid = parsed.filter((p) => p.error);

  const run = async (dryRun) => {
    const res = await onImportHistory({ entries: valid, dryRun });
    setResult(res ? { ...res, dryRun } : null);
  };

  return (
    <Card
      className={`aquamanCard ${isDarkMode ? "dark" : ""}`}
      title="Importo historikun"
    >
      <Input.TextArea
        rows={6}
        value={raw}
        placeholder={PLACEHOLDER}
        onChange={(e) => setRaw(e.target.value)}
      />
      <div className="aquamanImportMeta">
        <Tag color="green">{valid.length} rreshta të lexueshëm</Tag>
        {invalid.length ? (
          <Tag color="red">{invalid.length} rreshta të gabuar</Tag>
        ) : null}
      </div>
      <div className="aquamanImportActions">
        <MondayButton
          className="mondayButtonBlue"
          disabled={saving || valid.length === 0}
          onClick={() => run(true)}
        >
          Kontrollo
        </MondayButton>
        <MondayButton
          disabled={saving || valid.length === 0}
          onClick={() => run(false)}
        >
          Importo
        </MondayButton>
      </div>

      {result ? (
        <Alert
          style={{ marginTop: 12 }}
          type={result.unmatched?.length ? "warning" : "success"}
          showIcon
          message={`${result.dryRun ? "Kontroll" : "Importuar"}: ${
            result.imported
          } javë`}
          description={
            <>
              {result.unmatched?.length ? (
                <div>
                  Nuk u përputhën:{" "}
                  {result.unmatched
                    .map((u) => `${u.weekStartDate || "?"} ${u.employeeName || ""}`)
                    .join(", ")}
                </div>
              ) : null}
              {result.historicalButInactive?.length ? (
                <div>
                  Kanë shërbyer por nuk janë aktivë:{" "}
                  {result.historicalButInactive
                    .map((e) => e.employeeName)
                    .join(", ")}
                </div>
              ) : null}
            </>
          }
        />
      ) : null}
    </Card>
  );
};

export default HistoryImportPanel;
